var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.isButtonDisabled
      ? _c(
          "div",
          {
            class: _vm.infoClasses,
            on: { click: _vm.toggleLeadsToNoRecommendation },
          },
          [_c("info-icon")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "gallery-item-body",
        attrs: {
          href: "#",
          tabindex: _vm.tabIndex,
          "aria-disabled": _vm.galleryItemDisabled,
        },
        on: { click: _vm.clickOnItem },
      },
      [
        _c("img", {
          staticClass: "gallery-image",
          attrs: { src: _vm.item.image_url, alt: _vm.item.title },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title-overlay" }, [
          _c("div", { staticClass: "texts" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.item.title)),
            ]),
            _vm._v(" "),
            !!_vm.item.subtitle
              ? _c("div", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.item.subtitle)),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "arrow" }, [
            _c(
              "svg",
              {
                staticClass: "arrow-icon",
                attrs: { viewBox: "0 0 20 20", width: "20" },
              },
              [
                _c("use", {
                  attrs: {
                    "xlink:href": "#angle-right",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }